import { render, staticRenderFns } from "./elements.vue?vue&type=template&id=43534496&"
import script from "./elements.vue?vue&type=script&lang=js&"
export * from "./elements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports